export default __webpack_public_path__ + "static/media/IC00005-session_card.b6531e5e.svg";